import * as React from "react";

const useScroll = () => {
  const elRef = React.useRef<HTMLDivElement>(null);
  const doScroll = () => elRef?.current?.scrollIntoView({ behavior: "smooth" });

  return [doScroll, elRef];
};
export default useScroll;
